import {
  carGradient,
  electricityGradient,
  heatingGradient,
  infoGradient,
  solarGradient,
  successGradient,
} from '../theme/colors';

const netZeroContent = {
  NOW: {
    title: 'Your home now',
    titleGradient: infoGradient,
    nextButtonLabel: 'Solar',
    description:
      'Based on your data, your home and car emissions were {emissions} tonnes in {year}. ' +
      'A low carbon home would be under a tonne per year.',
  },
  SOLAR: {
    title: 'Install a solar array',
    titleGradient: solarGradient,
    nextButtonLabel: 'Insulate',
    description:
      "Loop's solar simulator identifies the optimal solar array and battery " +
      "for your house based on your data. In this example we've added a 4kW array but that's not optimal for everyone.",
  },
  INSULATE: {
    title: 'Insulation and efficiency',
    titleGradient: electricityGradient,
    nextButtonLabel: 'Electric Vehicle',
    description:
      "The best energy is the energy you don't use! Loop users reduce their usage by 10% on average. " +
      'Increase your efficiency and reduce your Phantom Load with Loop to cut your electricity usage. Draught proof ' +
      'and insulate your home to cut your heating needs.',
  },
  EV: {
    title: 'Swap from petrol/diesel to electric',
    titleGradient: carGradient,
    nextButtonLabel: 'Low carbon heat',
    description:
      "With an EV you're on the way to low carbon travel: CO2 emissions are a third of a petrol " +
      'equivalent car today, and EV emissions fall as the electricity grid decarbonises. If you ' +
      'have the flexibility, charging overnight will save you both money and carbon. Check out ' +
      "Loop's blog for all the EV advice you require.",
  },
  HEAT: {
    title: 'Low carbon heat',
    titleGradient: heatingGradient,
    nextButtonLabel: 'Net-zero',
    description:
      'Replace your boiler with a low carbon alternative such as a heat pump. Turn off your gas ' +
      'supply and cut your direct reliance on fossil fuels!',
  },
  GRID: {
    title: 'Your 2031 home',
    titleGradient: successGradient,
    nextButtonLabel: 'Interactive calculator',
    description:
      'Huge wind and solar farms are being built right now. By 2031 electricity production will ' +
      'produce 75% less carbon. With an all electric home, could your home become net-zero?',
  },
};

export default netZeroContent;
